import { c as _c } from "react/compiler-runtime";
import { isVaultDataDecrypted, isVaultDataText, US_STATES_AND_TERRITORIES, type VaultValue } from '@onefootprint/core';
import type { DataIdentifier, Entity } from '@onefootprint/request-types/dashboard';
import { EncryptedCell } from '@/components';
import Field from '../../../../../field';
export type StateType = {
  di: DataIdentifier;
  entity: Entity;
};
const getState = (state: VaultValue) => {
  const possibleState = US_STATES_AND_TERRITORIES.find(s => s.value === state);
  return possibleState?.label || state as string;
};
const State = t0 => {
  const $ = _c(3);
  const {
    di,
    entity
  } = t0;
  let t1;
  if ($[0] !== di || $[1] !== entity) {
    t1 = <Field di={di} entity={entity} renderValue={_temp} />;
    $[0] = di;
    $[1] = entity;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default State;
function _temp(value) {
  if (value && isVaultDataText(value) && isVaultDataDecrypted(value)) {
    return <div className="text-body-2 text-primary" data-dd-privacy="mask">{getState(value)}</div>;
  }
  return <EncryptedCell />;
}